import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

import '../style/servicesPages.css'
import Seo from '../components/Seo';

function DataAI(){
    const { t } = useTranslation();

    return(
        <section id='data-ai' className='block service-block'>
            <Seo path='/services/data-ai' titleKey='seo.dataAI.title' descriptionKey='seo.dataAI.description' />
            <Container fluid style={{marginTop: "50px"}}>
                <div className='title-holder'>
                    <h2>{t('dataAI.title')}</h2>
                    <div className='subtitle'>{t('dataAI.subtitle')}</div>
                </div>

                {/* Hero Section */}
                <Row style={{marginTop: "50px"}}>
                    <Col>
                        <div className='service-detail'>
                            <h3>{t('dataAI.hero.title')}</h3>
                            <p>{t('dataAI.hero.description')}</p>
                        </div>
                    </Col>
                    <Col>
                        <div className='image-service'>
                            <Image className='image-service-bootstrap flexible' src={require("../assets/images/ai-data-science.png")} rounded />
                        </div>
                    </Col>
                </Row>

                {/* Services Grid */}
                <div className='intermediate-title' style={{marginTop: "80px", marginBottom: "40px"}}>
                    <h3>{t('dataAI.servicesTitle')}</h3>
                </div>

                <Row className="g-4" style={{marginBottom: "60px"}}>
                    {/* AI Agents Card */}
                    <Col md={6}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-robot fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dataAI.services.agents.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dataAI.services.agents.description')}</Card.Text>
                                <ul className="mt-3">
                                    <li>{t('dataAI.services.agents.items.item1')}</li>
                                    <li>{t('dataAI.services.agents.items.item2')}</li>
                                    <li>{t('dataAI.services.agents.items.item3')}</li>
                                    <li>{t('dataAI.services.agents.items.item4')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                    
                    {/* Data Acquisition Card */}
                    <Col md={6}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-database fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dataAI.services.acquisition.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dataAI.services.acquisition.description')}</Card.Text>
                                <ul className="mt-3">
                                    <li>{t('dataAI.services.acquisition.items.item1')}</li>
                                    <li>{t('dataAI.services.acquisition.items.item2')}</li>
                                    <li>{t('dataAI.services.acquisition.items.item3')}</li>
                                    <li>{t('dataAI.services.acquisition.items.item4')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Data Analytics Card */}
                    <Col md={6}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-chart-line fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dataAI.services.analytics.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dataAI.services.analytics.description')}</Card.Text>
                                <ul className="mt-3">
                                    <li>{t('dataAI.services.analytics.items.item1')}</li>
                                    <li>{t('dataAI.services.analytics.items.item2')}</li>
                                    <li>{t('dataAI.services.analytics.items.item3')}</li>
                                    <li>{t('dataAI.services.analytics.items.item4')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Predictive Models Card */}
                    <Col md={6}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-brain fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dataAI.services.predictive.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dataAI.services.predictive.description')}</Card.Text>
                                <ul className="mt-3">
                                    <li>{t('dataAI.services.predictive.items.item1')}</li>
                                    <li>{t('dataAI.services.predictive.items.item2')}</li>
                                    <li>{t('dataAI.services.predictive.items.item3')}</li>
                                    <li>{t('dataAI.services.predictive.items.item4')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Benefits Section */}
                <Row style={{marginTop: "80px", marginBottom: "60px"}}>
                    <Col>
                        <div className='image-service'>
                            <Image className='image-service-bootstrap flexible' src={require("../assets/images/data-analytics-2.jpg")} rounded />
                        </div>
                    </Col>
                    <Col>
                        <div className='service-detail'>
                            <h3>{t('dataAI.benefits.title')}</h3>
                            <p>{t('dataAI.benefits.description')}</p>
                            <ul>
                                <li><strong>{t('dataAI.benefits.items.item1.title')}</strong> {t('dataAI.benefits.items.item1.description')}</li>
                                <li><strong>{t('dataAI.benefits.items.item2.title')}</strong> {t('dataAI.benefits.items.item2.description')}</li>
                                <li><strong>{t('dataAI.benefits.items.item3.title')}</strong> {t('dataAI.benefits.items.item3.description')}</li>
                                <li><strong>{t('dataAI.benefits.items.item4.title')}</strong> {t('dataAI.benefits.items.item4.description')}</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default DataAI;
